// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover___1cWj8","coverEdit":"coverEdit___1fT4l","FInput":"FInput___1eU-q","btn":"btn___3TcPU"};